import React, { Component, useEffect, useState } from 'react';

import { Switch, Route, Redirect, useHistory } from 'react-router-dom';
import { useLocation } from 'react-router';
import { ThemeProvider } from '@mui/material/styles';
import Themes from "./components/themes";
import PrivateRoute from './components/PrivateRoute';
import { useSelector } from 'react-redux';
import Splash from './components/Splash';
import { LoginResponse } from "./dto/auth.dto";
import Sidbar from './components/Sidbar/Sidbar';
import { getAuth } from './assets/redux/AuthRedux';
import { getTheme } from './assets/redux/ThemeRedux';
import Loader from './components/Loader';
import { Actions, getDictionary } from "./assets/redux/DictionaryRedux";
import { useDispatch } from 'react-redux';
// import { EN } from "./assets/language/en";
// import { FA } from "./assets/language/fa";
import { GetRequest } from './assets/dataProvider';
import { RouteList } from './config/routeConfig';
import Footer from './components/footer/Footer';
import { ActionSetting } from './assets/redux/SettingRedux';
const NotFound = React.lazy(() => import('./views/Errors/NotFound'));
function App(props: any) {
  const location = useLocation();
  const history = useHistory();
  const isDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
  const [showSplash, setShowSplash] = useState(true);
  const [isloading, setIsloading] = useState(true);
  const [useDarkTheme, setUseDarkTheme] = useState(false);
  const dispatch = useDispatch();
  const userData = useSelector((state: any) => getAuth(state.AuthRedux)) as LoginResponse;
  const isDark = useSelector((state: any) => getTheme(state.ThemeRedux));


  const loadLanguage = async () => {
    let lan = localStorage.getItem('current_lan');
    if (!lan) {
      lan = 'fa';
      localStorage.setItem('current_lan', lan);
    }
    var res = await GetRequest('api/v1/translations/' + lan, {});
    if (res.success) {
      dispatch(Actions.SetDictionary(res.entity?.translations));
    }
    var res = await GetRequest('api/v2/shop/setting', {});
    if (res.success) {
      dispatch(ActionSetting.SetSetting(res.entity));
    }
    setIsloading(false);
  }

  useEffect(() => {
    loadLanguage();
  }, []);
  useEffect(() => {
    if (!isloading) {
      setTimeout(() => {
        setShowSplash(false);
      }, 2500)
    }
  }, [isloading]);
  if (showSplash)
    return <Splash />;
  return (isloading ? <Loader /> :
    <ThemeProvider theme={Themes.dark}>

      <React.Suspense fallback={<Loader />}>
        <Sidbar visiable={(userData && userData.token) ? true : false} history={history}>
          <Switch >
            {RouteList.filter(r => r.auth).map((RouteItem, index) => (

              <PrivateRoute key={index} path={RouteItem.path} exact={RouteItem.exact} component={props => RouteItem.component} />

            ))}
            {RouteList.filter(r => !r.auth).map((RouteItem, index) => (

              <Route key={index} path={RouteItem.path} exact={RouteItem.exact} render={props => RouteItem.component} />

            ))}
            <Route path="/404" exact render={props => <NotFound {...props} />} />
            <Route render={props => <Redirect to="/404" />} />
          </Switch>
        </Sidbar>

        {userData && userData.token && <Footer />}

      </React.Suspense>
    </ThemeProvider>
  );

}

export default App;